<div class="price-overrides">
  <h4>Clients Price Override</h4>
  <ng-container *ngIf="(loading$ | async) === false; else loader">
    <div class="list" *ngIf="clientsPriceOverride.length; else noRecords">
      <table class="table table-stripped">
        <thead>
          <tr>
            <th>Business Name</th>
            <th class="text-right">Price Override</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let clientPrice of clientsPriceOverride">
            <td>
              <a
                href="/clients/{{ clientPrice.businessAccountId }}/profile"
                target="_blank"
              >
                {{ clientPrice.businessName }}
              </a>
            </td>
            <td class="text-right">
              {{ clientPrice.price | currency: '' }}
            </td>
          </tr>
        </tbody>
      </table>
      <mat-paginator
        *ngIf="pagination$ | async as pagination"
        [length]="pagination?.total"
        [pageSize]="pagination?.per_page"
        [pageSizeOptions]="paginationConfig?.pageSizeOptions"
        [pageIndex]="pagination?.current_page - 1"
        (page)="onPaginationEvent($event)"
        aria-label="Select page"
      >
      </mat-paginator>
    </div>
  </ng-container>
</div>

<ng-template #loader>
  <div class="spinner"><mat-spinner diameter="50"></mat-spinner></div>
</ng-template>

<ng-template #noRecords>
  <div class="text-center p-4">
    <h3>No records available.</h3>
  </div>
</ng-template>
